import { useMemo } from 'react';
import jwtDecode from 'jwt-decode';
import { TokenData } from 'lib/type';

const useIsAccountActivationRequired = () => {
    return useMemo(() => {
        try {
            const token = localStorage.getItem('accessToken');
            if (!token) return false;

            const decodedToken = jwtDecode<TokenData>(token);
            return Boolean(decodedToken.readOnly);
        } catch (error) {
            console.error('Failed to decode token:', error);
            return false;
        }
    }, []);
};

export default useIsAccountActivationRequired;
